import { RouteConfig } from 'vue-router';

import { getPaymentPackDetails } from '@/utils/paymentList';
import Payments from '@/views/mainRoute/procedure/payments/Payments.vue';

export const procedurePaymentsRoute: RouteConfig = {
  path: ':packId',
  name: 'procedurePayments',
  component: Payments,
  meta: {
    breadcrumb: { title: 'Płatności' },
    header: { title: 'Płatności' }
  },
  beforeEnter: (to, from, next) => {
    getPaymentPackDetails(to).then(() => next());
  }
};
